import React from 'react';
import { useDispatch } from 'react-redux';
import cn from 'classnames';
import Toolbar from '../../common/Toolbar/Toolbar';
import MainNav from '../MainNav/MainNav';
import SelectCompany from './components/SelectCompany';
import Search from './components/Search';
import Action from './components/Action';
import HousesViewTabs from '../HousesViewTabs/HousesViewTabs';
import useHousingStockMatch from '../../../hooks/useHousingStockMatch';
import { links } from '../../../constants/links';
import {
  resetSearchFieldValue,
  setFlatsTablePage,
  setHousesTablePage,
} from '../../../store/actions/housingStockActions';
import styles from './MainHeader.module.scss';

const MainHeader = ({ className, dropdownBtnTextColor = 'gray' }) => {
  const match = useHousingStockMatch();
  const dispatch = useDispatch();

  const { page, pageTab } = match?.params;

  const showHousesViewTabs = page === links.houses && !pageTab;
  const isExportsPage = page === links.exports;
  const isReportRSOPage = page === links.reportRSO;
  const isImportsPage = page === links.imports;

  return (
    <Toolbar
      isHeader
      background="light"
      className={cn(className, styles.toolbar)}
    >
      <MainNav
        onLinkClick={() => {
          dispatch(resetSearchFieldValue());
          dispatch(setHousesTablePage(0));
          dispatch(setFlatsTablePage(0));
        }}
      />
      {!(isImportsPage || isExportsPage || isReportRSOPage) && (
        <>
          <Search />
          <Action />
        </>
      )}
      {!isReportRSOPage && (
        <SelectCompany dropdownBtnTextColor={dropdownBtnTextColor} />
      )}
      {showHousesViewTabs && <HousesViewTabs />}
    </Toolbar>
  );
};

export default MainHeader;
